import React, { useEffect, useState } from 'react';
import './styles.css';
import LogAnalysis from '../../container/User-panel/AnalysisPopup/LogAnalysis';
import CompleteAnalysis from '../../container/User-panel/AnalysisPopup/CompleteAnalysis';
import AppServices from '../../../services/appServices';
import { APIEndpoint } from '../../../config/apiendpoint';
import { convertDate } from '../../utils/dateHelper';
import { Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { TailSpin } from 'react-loader-spinner';
import moment from 'moment';
import PreviewModal from '../reportPdfModel/PreviewModal';
import { FaEye } from "react-icons/fa6";

function ThirtyDayAnalysis({ patientData, staffList, updateLog }) {
  const _appServices = new AppServices();
  const [showPopup, setShowPopup] = useState(false);
  const [showCompleteAnalysis, setShowCompleteAnalysis] = useState(false);
  const [logDatas, setLogDatas] = useState(null);
  const [logAnalysisData, setLogAnalysisData] = useState()
  const [btnActive, setIsBtnActive] = useState(false);
  const [loading,setLoading] = useState(true);
  const [showPreview,setShowPreview] = useState(false);
  const [showNoteWindow, setShowNoteWindow] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [previewDataLoading,setPreviewDataLoading] = useState(false);
  const [selectedPreviewData,setSelectedPreviewData]=useState({})

  const [popupState, setPopupState] = useState({
    show: false,
    data: null
  });


  const handlePendingClick = (entry) => {
    // setLogAnalysisData(entry)
    // setShowPopup(true);
    setPopupState({
      show: true,
      data: entry
    });
   
  };



  const handleCompleteAnalysis = (entry) => {
    setShowCompleteAnalysis(true)
    setLogAnalysisData(entry)
  }

  const handleClose = () => {
    setPopupState({
      show: false,
      data: null
    });
  };

  const handlePreviewClose = ()=>{
    setShowNoteWindow(false)
    setShowPreview(false)
    setIsMinimized(false)
  }
  const updateAnalysis = () => {
    getThirtyDayAnalysis()
    updateLog()
  }
  useEffect(() => {
    getThirtyDayAnalysis()
  }, [])

  const fetchTestData = async () => {
    try {
      if (logDatas?.length > 0) {
        return
      }
      const resp = await _appServices.postData(`${APIEndpoint.fetchTestData}/${patientData?.uuid}`);
      window.location.reload();

      // if (resp.status === 201 ) {
      //   console.log("dubbby data",resp)
      //   Swal.fire({
      //         icon: "success",
      //         title: "Success",
      //         text: resp?.message ,
      //       }).then(()=>{
      //         window.location.reload();
      //       })

      // }
    } catch (error) {
      console.error("Error fetching datad:", error);
    }
  }

  const getThirtyDayAnalysis = async () => {
    try {
      setLoading(true)
      const resp = await _appServices.getData(`${APIEndpoint.logAnalysis}?patientUid=${patientData?.uuid}`);
      if (resp?.status === 200 && resp?.success == true) {
        let data = resp.data
        let addLogDatas = []
        if (data && data.logDatas?.length) {
          data.logDatas.map((item) => {
            addLogDatas.push({
              cycleEndDate: convertDate(item.cycleEndDate),
              analysis: item.analysis,
              staff: item.status ? `${item?.createdBy?.firstName} ${item?.createdBy?.lastName}` : '',
              dateComplete: item.status ? convertDate(item.completedAt) : 'PENDING',
              id: item.uuid,
              completedReadingCount: item.completedReadingCount,
              item: item,
              analysisNotes: item.analysisNotes,
              staffUid: item.status ? `${item?.createdBy?.uuid}` : ''
            })
          })
          setLogDatas(addLogDatas)
          // console.log(data.logDatas, "logged item")
         
        }
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.error("Error fetching data:", error);
    }
  }

  const getPreviewData = async (selectedRow) => {

    setPreviewDataLoading(true)
    
    setPreviewData(null)
    // console.log("`${APIEndpoint.previewAnalysis}/${selectedRow.id}?patientUid=${patientData?.uuid}`",`${APIEndpoint.previewAnalysis}/${selectedRow.id}?patientUid=${patientData?.uuid}`)
    try {
      const resp = await _appServices.getData(
        `${APIEndpoint.previewAnalysis}/${selectedRow.id}?patientUid=${patientData?.uuid}`
      );
      if (resp.status === 200 && resp.success == true) {
        
        switch (resp.data.measurement) {
          case 'Blood Pressure': {
            const modifyData = resp.data.readingDatas.map(item => ({
              date: item.dateTime,
              range: `${item.systolic}/${item.diastolic}`,
              systolic: item.systolic,
              diastolic: item.diastolic,
              device: item.deviceType,
              unit: item.bloodPressureUnits,
              isAbnormalDiastolic: item.isAbnormalDiastolic,
              isAbnormalSystolic: item.isAbnormalSystolic,
              danger: item.isAbnormalDiastolic || item.isAbnormalSystolic
            }));
            resp.data.readingDatasPressure = modifyData;
            break;
          }
          case 'Blood Glucose Level': {
            const modifyData = resp.data.readingDatas.map(item => ({
              date: item.dateTime,
              range: item.glucoseReading,
              isAbnormalGlucoseReading: item.isAbnormalGlucoseReading,
              device: item.deviceType ? item.deviceType : 'Accu-Chek',
              unit: item.readingUnit
            }));
            resp.data.readingDatasGlucose = modifyData;
            break;
          }
          default:
            // Handle other cases or a default action if needed
            console.warn('Unknown measurement type:', resp.data.measurement);
        }
        setPreviewData(resp.data);
        setPreviewDataLoading(false)
      }
      _appServices.logData({
        Severity: 'Info',
        Activity: `User viewed completed Report archive pdf.`,
        ActivityStatus: 'Success',
        ActivityResponse: 'Page View',
        Operation: 'User Activity',
      })
    } catch (error) {
      console.error("Error fetching datad:", error);
      setPreviewDataLoading(false)
      _appServices.logData({
        Severity: 'Error',
        Activity: `User failed to view completed Report archive pdf.`,
        ActivityStatus: 'Failure',
        ActivityResponse: 'Page View',
        Operation: 'User Activity',
      })
    }
  };

  const handlePreviewClick = (entry)=>{
    // console.log("entryeee",entry)
    setSelectedPreviewData(entry)
    setShowPreview(true);
    setLogAnalysisData(entry)
    getPreviewData(entry)
  }

  return (
    <div className="graph-container">

      <div className='d-flex justify-content-between'> <h2 className='graphHeading ml-5 mb-4'>30-Day Analysis</h2></div>
      <div className="bordertable-container ml-5">
        <table className="borderdata-table">
          <thead>
            <tr>
              <th>Cycle End Date</th>
              <th>Analysis</th>
              {/* <th>Readings Count</th> */}
              <th>Staff Name</th>
              <th style={{textAlign:'center' }}>Preview</th>
              <th>Date Complete</th>
            </tr>
          </thead>
          <tbody>
            {logDatas?.length ? logDatas.map((entry, index) => (
              <tr key={index}>
                <td>{entry.cycleEndDate}</td>
                <td>{entry.analysis}</td>
                {/* <td>{entry.completedReadingCount}</td> */}
                <td>{entry.staff}</td>
               {entry.dateComplete.toLowerCase() === 'pending' ?
                <td style={{ cursor: 'pointer',textAlign:'center' }} onClick={()=>{handlePreviewClick(entry)}}><FaEye size={20} color='#89C9F8'/></td>
              :<td></td>} 
                <td style={{ color: '#03A84E' }}>
                  {entry.dateComplete.toLowerCase() === 'pending' ? (
                    <span className="pending" onClick={() => handlePendingClick(entry)}>
                      {entry.dateComplete}
                    </span>
                  ) : (
                    // entry.dateComplete
                    <span style={{ cursor: 'pointer' }} onClick={() => handleCompleteAnalysis(entry)}>{entry.dateComplete}</span>
                  )}
                </td>
              </tr>
            )) : null}
          </tbody>
        </table>
        {
          loading == true && <div className="d-flex align-items-center justify-content-center pt-5">
          <TailSpin
              visible={true}
              height="40"
              width="40"
              color="#03A84E"
              ariaLabel="tail-spin-loading"
              radius="1"
          />
      </div>
        }
        {(logDatas == null && loading == false) && (
          <div className="d-flex align-items-center justify-content-center pt-2">
            <p className="graphText thin-heading">No Data Found</p>
          </div>
        )}
      </div>

      {/* {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h3>Popup Title</h3>
            <p>{popupContent}</p>
            <button onClick={handleClose}>Close</button>
          </div>
        </div>
      )} */}
      <LogAnalysis show={popupState.show} patientData={patientData} onHide={handleClose} analysisData={popupState.data} staffList={staffList} onUpdate={updateAnalysis} />
      <CompleteAnalysis show={showCompleteAnalysis} patientData={patientData} onHide={() => { setShowCompleteAnalysis(false) }} analysisData={logAnalysisData} staffList={staffList} />
      <PreviewModal 
      showModal={showPreview} 
      handleClose={handlePreviewClose} 
      analysisData={logAnalysisData} 
      patientData={patientData} 
      staffList={staffList} 
      onUpdate={()=>getPreviewData(selectedPreviewData)} 
      data={previewData}
      showNoteWindow={showNoteWindow}
      setShowNoteWindow={setShowNoteWindow}
      isMinimized={isMinimized}
      setIsMinimized={setIsMinimized}
      loading={previewDataLoading}
      refresh3oDayTable = {updateAnalysis}
      // selectedRowData ={selectedPreviewData}
      />
    </div>
  );
}

export default ThirtyDayAnalysis;
